import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

const responseBody = (response: AxiosResponse) => response.data;

export const buildRequests = (instance: AxiosInstance) => {
  const requests = {
    get: (url: string, config: AxiosRequestConfig = {}) =>
      instance.get(url, config).then(responseBody),

    post: <TResponse = any, TRequest = any>(url: string, data?: TRequest, config: AxiosRequestConfig = {}) =>
      instance.post<TResponse>(url, data, config).then(responseBody),

    put: <TResponse = any, TRequest = any>(url: string, data?: TRequest, config: AxiosRequestConfig = {}) =>
      instance.put<TResponse>(url, data, config).then(responseBody),

    delete: (url: string, config: AxiosRequestConfig = {}) =>
      instance.delete(url, config).then(responseBody),

    patch: <TResponse = any, TRequest = any>(url: string, data?: TRequest, config: AxiosRequestConfig = {}) =>
      instance.patch<TResponse>(url, data, config).then(responseBody),

    search: <TResponse = any, TRequest = any>(url: string, data?: TRequest, config: AxiosRequestConfig = {}) =>
      instance.post<TResponse>(url, data, config).then(responseBody),

    export: <TRequest = any>(url: string, data?: TRequest, config: AxiosRequestConfig = {}) =>
      instance.post(url, data, { ...config, responseType: 'blob' }).then(responseBody),
  };

  return requests;
};
